"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MeetingJoinResponse = exports.MeetingExtendResponse = exports.MeetingExtendRequest = exports.MeetingRescheduleResponse = exports.MeetingRescheduleConfirmation = exports.MeetingRescheduleModeEnum = exports.MeetingRescheduleRequest = exports.MeetingLeaveResponse = exports.MeetingLeaveConfirmation = exports.MeetingCancelResponse = exports.MeetingCancelConfirmation = exports.ConfirmationOptions = exports.MeetingCheckoutResponse = exports.MeetingCheckoutRequest = void 0;
var lodash_1 = require("lodash");
var billing_1 = require("../../billing");
var helpers_1 = require("../../helpers");
var interfaces_1 = require("../../interfaces");
var meeting_1 = require("./meeting");
var meeting_participant_1 = require("./meeting-participant");
/** Запрос на данные для оплаты митинга */
var MeetingCheckoutRequest = /** @class */function () {
  function MeetingCheckoutRequest(values) {
    if (!values) {
      return;
    }
    this.meeting_id = values.meeting_id;
    this.account_id = values.account_id;
    this.currency_id = values.currency_id;
  }
  return MeetingCheckoutRequest;
}();
exports.MeetingCheckoutRequest = MeetingCheckoutRequest;
/** Ответ на запрос о данных для оплаты митинга */
var MeetingCheckoutResponse = /** @class */function (_super) {
  __extends(MeetingCheckoutResponse, _super);
  function MeetingCheckoutResponse(values) {
    var _this = _super.call(this, values) || this;
    if (values) {
      _this.meeting = values.meeting ? new meeting_1.Meeting(values.meeting) : null;
    }
    return _this;
  }
  return MeetingCheckoutResponse;
}(interfaces_1.CommonProcessingResponse);
exports.MeetingCheckoutResponse = MeetingCheckoutResponse;
/** Настройки диалога подтверждения */
var ConfirmationOptions = /** @class */function () {
  function ConfirmationOptions() {}
  return ConfirmationOptions;
}();
exports.ConfirmationOptions = ConfirmationOptions;
var MeetingCancelConfirmation = /** @class */function () {
  function MeetingCancelConfirmation(values) {
    if (!values) {
      return;
    }
    (0, lodash_1.assign)(this, (0, lodash_1.pick)(values, ['can', 'penalty', 'confirmation', 'confirmation_id']));
    if (values.penalty) {
      this.penalty = new billing_1.CCurrencyAmount(values.penalty);
    }
  }
  return MeetingCancelConfirmation;
}();
exports.MeetingCancelConfirmation = MeetingCancelConfirmation;
/** Ответ на запрос об отмене митинга */
var MeetingCancelResponse = /** @class */function (_super) {
  __extends(MeetingCancelResponse, _super);
  function MeetingCancelResponse(values) {
    var _this = _super.call(this, values) || this;
    if (values) {
      _this.model = values.model ? new meeting_1.Meeting(values.model) : null;
    }
    return _this;
  }
  return MeetingCancelResponse;
}(interfaces_1.CommonProcessingResponse);
exports.MeetingCancelResponse = MeetingCancelResponse;
var MeetingLeaveConfirmation = /** @class */function () {
  function MeetingLeaveConfirmation(values) {
    if (!values) {
      return;
    }
    (0, lodash_1.assign)(this, (0, lodash_1.pick)(values, ['can', 'penalty', 'confirmation', 'confirmation_id']));
    if (values.penalty) {
      this.penalty = new billing_1.CCurrencyAmount(values.penalty);
    }
  }
  return MeetingLeaveConfirmation;
}();
exports.MeetingLeaveConfirmation = MeetingLeaveConfirmation;
/** Ответ на запрос о прекращении участия в митинге */
var MeetingLeaveResponse = /** @class */function (_super) {
  __extends(MeetingLeaveResponse, _super);
  function MeetingLeaveResponse(values) {
    var _this = _super.call(this, values) || this;
    if (values) {
      _this.model = values.model ? new meeting_1.Meeting(values.model) : null;
    }
    return _this;
  }
  return MeetingLeaveResponse;
}(interfaces_1.CommonProcessingResponse);
exports.MeetingLeaveResponse = MeetingLeaveResponse;
var MeetingRescheduleRequest = /** @class */function () {
  function MeetingRescheduleRequest(values) {
    if (values) {
      helpers_1.ValueValidation.assertDate('begin_at', values.begin_at);
      this.begin_at = new Date(values.begin_at);
    }
  }
  return MeetingRescheduleRequest;
}();
exports.MeetingRescheduleRequest = MeetingRescheduleRequest;
/** Способы переноса времени митинга */
var MeetingRescheduleModeEnum;
(function (MeetingRescheduleModeEnum) {
  /** Перенос преподавателем единолично */
  MeetingRescheduleModeEnum[MeetingRescheduleModeEnum["immediate"] = 1] = "immediate";
  /** Перенос после подтверждения участниками */
  MeetingRescheduleModeEnum[MeetingRescheduleModeEnum["participants_approved"] = 2] = "participants_approved";
  /** Перенос после голосования участниками */
  MeetingRescheduleModeEnum[MeetingRescheduleModeEnum["participants_voted"] = 3] = "participants_voted";
})(MeetingRescheduleModeEnum = exports.MeetingRescheduleModeEnum || (exports.MeetingRescheduleModeEnum = {}));
var MeetingRescheduleConfirmation = /** @class */function () {
  function MeetingRescheduleConfirmation(values) {
    if (!values) {
      return;
    }
    (0, lodash_1.assign)(this, (0, lodash_1.pick)(values, ['can', 'mode', 'confirmation', 'confirmation_id']));
  }
  return MeetingRescheduleConfirmation;
}();
exports.MeetingRescheduleConfirmation = MeetingRescheduleConfirmation;
/** Ответ на запрос на перенос времени митинге */
var MeetingRescheduleResponse = /** @class */function (_super) {
  __extends(MeetingRescheduleResponse, _super);
  function MeetingRescheduleResponse(values) {
    var _this = _super.call(this, values) || this;
    if (values) {
      _this.model = values.model ? new meeting_1.Meeting(values.model) : null;
    }
    return _this;
  }
  return MeetingRescheduleResponse;
}(interfaces_1.CommonProcessingResponse);
exports.MeetingRescheduleResponse = MeetingRescheduleResponse;
/** Запрос на продление митинга */
var MeetingExtendRequest = /** @class */function () {
  function MeetingExtendRequest(values) {
    if (values) {
      helpers_1.ValueValidation.assertInteger('hours', values.hours);
      this.hours = values.hours;
    }
  }
  return MeetingExtendRequest;
}();
exports.MeetingExtendRequest = MeetingExtendRequest;
/** Ответ на запрос на продление митинге */
var MeetingExtendResponse = /** @class */function (_super) {
  __extends(MeetingExtendResponse, _super);
  function MeetingExtendResponse(values) {
    var _this = _super.call(this, values) || this;
    if (values) {
      _this.model = values.model ? new meeting_1.Meeting(values.model) : null;
    }
    return _this;
  }
  return MeetingExtendResponse;
}(interfaces_1.CommonProcessingResponse);
exports.MeetingExtendResponse = MeetingExtendResponse;
/** Ответ на запрос на подключение к митингу */
var MeetingJoinResponse = /** @class */function (_super) {
  __extends(MeetingJoinResponse, _super);
  function MeetingJoinResponse(values) {
    var _this = _super.call(this, values) || this;
    if (values) {
      _this.model = values.model ? new meeting_1.Meeting(values.model) : null;
      _this.participant = values.participant ? new meeting_participant_1.MeetingParticipant(values.participant) : null;
    }
    return _this;
  }
  return MeetingJoinResponse;
}(interfaces_1.CommonProcessingResponse);
exports.MeetingJoinResponse = MeetingJoinResponse;
